// Footer.tsx
import React from 'react';
import './Footer.css'; // Asume que tienes un archivo Footer.css para los estilos
import faceSVG from '../Iconos/facebook.svg';
import youtubeSVG from '../Iconos/youtube.svg';
import xsvg from '../Iconos/X_logo.svg';
const Footer: React.FC = () => {
  return (
    <footer className="social-footer">
      <a href="https://twitter.com" target="_blank" rel="noopener noreferrer">
        <img src={xsvg} alt="Twitter" />
      </a>
      <a href="https://youtube.com" target="_blank" rel="noopener noreferrer">
        <img src={youtubeSVG} alt="YouTube" />
      </a>
      <a href="https://facebook.com" target="_blank" rel="noopener noreferrer">
        <img src={faceSVG} alt="Facebook" />
      </a>
    </footer>
  );
};

export default Footer;
